import { dependencies } from '../../../package.json';

export const DYNAMIC_API_VERSION_HEADER = 'x-dyn-api-version';

export const DYNAMIC_REQUEST_ID_HEADER = 'x-dyn-request-id';

export const DYNAMIC_SDK_VERSION_HEADER = 'x-dyn-version';

export const MFA_TOKEN_HEADER = 'x-mfa-auth-token';

export const SESSION_PUBLIC_KEY_HEADER = 'x-dyn-session-public-key';

export const DYNAMIC_SDK_API_VERSION =
  dependencies['@dynamic-labs/sdk-api-core'];

export const CLIENT_SDK_NAME = 'ClientSDK';
